import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Audioknigi from '@/components/screens/audioknigi/Audioknigi';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IAudioBooksVisitedDynamicPage extends IWidgetsSideBar {
  books: IBookPage;
}

const AudioBooksVisitedDynamicPage: NextPage<IAudioBooksVisitedDynamicPage> = ({ books, todayWidget, popularBooksWidget }) => {
  useRedirectToFirstPage('/new_audioknigi/sorting/visited/');
  return <Audioknigi books={books} sortingName="по просмотрам" sortingUrl={'sorting/visited'} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/books?book_type=audio_book&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_field=views_count&sort_reversed=true`)]);
  const [books] = await Promise.all([booksRes.json()]);

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { books, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default AudioBooksVisitedDynamicPage;
